import React, { useState, useRef, useEffect } from 'react';
import { PERMISSIONS } from './permissionMeta';

/**
 * Filter bar: free-text search, platform, and the 15-permission multi-select.
 * Presentational — all state lives in the container.
 */
const GROUPS = [{ key: 'watch', label: 'Watch' }, { key: 'mobile', label: 'Mobile' }];

const PermissionFilters = ({
  searchValue, platform, permissions, showClear,
  onSearchChange, onPlatformChange, onPermissionToggle, onSearch, onClear, onClearPermissions,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDocClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const selectedCount = Object.values(permissions || {}).filter(Boolean).length;
  const permLabel = selectedCount ? `${selectedCount} permission${selectedCount > 1 ? 's' : ''} selected` : 'All permissions';

  return (
    <div className="au-filters up-filters">
      <div className="au-field">
        <label className="au-field__label" htmlFor="up-search">Search</label>
        <input
          id="up-search" className="au-input" type="text" placeholder="Search"
          value={searchValue} onChange={(e) => onSearchChange(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') onSearch(); }}
        />
      </div>

      <div className="au-field">
        <label className="au-field__label" htmlFor="up-platform">Platform</label>
        <select id="up-platform" className="au-select" value={platform} onChange={(e) => onPlatformChange(e.target.value)}>
          <option value="">All platforms</option>
          <option value="android">Android</option>
          <option value="ios">iOS</option>
        </select>
      </div>

      <div className="au-field" ref={ref}>
        <label className="au-field__label">Permissions</label>
        <div className="up-multiselect">
          <button type="button" className="au-select up-perm-trigger" data-testid="up-perm-trigger" onClick={() => setOpen((o) => !o)}>
            <span>{permLabel}</span>
            <span aria-hidden="true">{open ? '▲' : '▼'}</span>
          </button>
          {open && (
            <div className="up-perm-menu" data-testid="up-perm-menu">
              <div className="up-perm-menu__head">
                <span>{selectedCount ? `${selectedCount} selected` : 'Select permissions'}</span>
                {selectedCount > 0 && onClearPermissions && (
                  <button type="button" className="up-perm-menu__clear" onClick={onClearPermissions}>Clear</button>
                )}
              </div>
              <div className="up-perm-menu__body">
                {GROUPS.map((g) => (
                  <div className="up-perm-group" key={g.key}>
                    <div className="up-perm-group__label">{g.label}</div>
                    {PERMISSIONS.filter((p) => p.platform === g.key).map((p) => (
                      <label key={p.key} className={`up-perm-item${permissions && permissions[p.key] ? ' up-perm-item--on' : ''}`}>
                        <input type="checkbox" checked={!!(permissions && permissions[p.key])} onChange={() => onPermissionToggle(p.key)} />
                        <span>{p.label}</span>
                      </label>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="au-field au-field--actions">
        <button type="button" className="au-btn au-btn--primary" onClick={onSearch}>Search</button>
        {showClear && <button type="button" className="au-btn au-btn--ghost" onClick={onClear}>Clear</button>}
      </div>
    </div>
  );
};

export default PermissionFilters;
